import * as nodeUtils from "util";
import { ElementRef } from "@angular/core";
import { Router } from "@angular/router";
import { List } from "linq-collections";

class LocalUtils {
  public jsonStringifySafe(value: any): string {
    let cache = [];
    let result = JSON.stringify(value, function(key, value) {
      if(typeof value === 'object' && value !== null){
        if(cache.indexOf(value) !== -1){
          // Circular reference found, discard key
          return;
        }
        // Store value in our collection
        cache.push(value);
      }
      return value;
    });
    cache = null; // Enable garbage collection. NOTE: At the end of the method, it is GC-d anyway, isn't it?

    return result;
  }

  /**
   * Calculate the top left position of the targetElement
   * @param {Document} document
   * @param {HTMLElement} targetElement
   * @returns {{top: number, left: number}}
   */
  public extractElementPosition(document: Document, targetElement: HTMLElement): { top: number, left: number } {

    let body = document.body;
    let docEl = document.documentElement;

    let windowPageYOffset: number = document.defaultView && document.defaultView.pageYOffset || undefined;
    let windowPageXOffset: number = document.defaultView && document.defaultView.pageXOffset || undefined;

    let scrollTop = windowPageYOffset || docEl.scrollTop || body.scrollTop;
    let scrollLeft = windowPageXOffset || docEl.scrollLeft || body.scrollLeft;

    let clientTop = docEl.clientTop || body.clientTop || 0;
    let clientLeft = docEl.clientLeft || body.clientLeft || 0;

    if(!targetElement){
      // No element found, so return the current position to not cause any change in scroll position
      return {top: scrollTop, left: scrollLeft};
    }
    let box = targetElement.getBoundingClientRect();

    let top = box.top + scrollTop - clientTop;
    let left = box.left + scrollLeft - clientLeft;

    return {top: Math.round(top), left: Math.round(left)};
  }

  /**
   * @argument elementRef The underlying native element
   */
  public offset(elementRef: ElementRef | any): {left: number, top: number} {
    if(!elementRef)
      throw new Error("Argument elementRef must be provided. ");

    let nativeElement = elementRef;
    if(elementRef instanceof ElementRef){
      nativeElement = elementRef.nativeElement;
    }

    var $element = $(nativeElement);
    return $element.offset();
  }

  /**
   * Checks if the given number is the power of 2.
   * In binary number format, this means it only contains one 1.
   * Like these: 0000001, 0000010, 0000100, 0001000, 0010000, 0100000, 1000000
   *
   * Based on:
   * http://www.exploringbinary.com/ten-ways-to-check-if-an-integer-is-a-power-of-two-in-c/
   */
  public isPowerOfTwo(x: number): boolean {
    return ((x != 0) && !(x & (x - 1)));
  }

  public getAnchor = (nativeHtmlElement: Element | any, attributeNames?: string[]): string => {
    let anchor = "";
    let anchorAttribute = this.getFirstExistingAttribute(nativeHtmlElement, attributeNames || ['href']);
    if(anchorAttribute && anchorAttribute.startsWith("#")){
      anchor = anchorAttribute.substr(1);
    }
    return anchor;
  }

  /**
   * Returns the value of the first attribute existing on the HTML element
   * @param nativeHtmlElement
   * @param attributeNames ['attr1', 'attr2', ...] --> If attr1 exists on the HTML element, returns its value. If not, then
   *                       if attr2 exists on the HTML element, returns its value, and so on...
   * @returns {string} Null if none of the attributes exist on the HTML element.
   */
  public getFirstExistingAttribute = (nativeHtmlElement: Element | any, attributeNames: string | string[]): string => {
    if(!nativeHtmlElement || !nativeHtmlElement.getAttribute || !attributeNames) {
      return null;
    }

    if(typeof attributeNames === 'string'){
      attributeNames = [<string>attributeNames];
    }
    let attributeNameList = new List<string>(attributeNames);

    let firstExistingAttributeValue = attributeNameList
      .select(attributeName => nativeHtmlElement.getAttribute(attributeName))
      .where(x => x || x === "")
      .firstOrDefault();

    return firstExistingAttributeValue;
  }

  public writeAnchorToUrl(router: Router, anchor: string): void {
    router.navigate([], {
      fragment: anchor,
      queryParamsHandling: "preserve",
      replaceUrl: true,
    });
  }
}

export class Utils {
  static nodeUtils = nodeUtils;
  static local = new LocalUtils();
}

export default Utils;



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/shared/utils/utils.ts